<template>
  <v-container grid-list-lg>

    <v-layout class="desktop-view-container" column="column" fill-height="fill-height">
      <v-card class="border-r-0">
        <v-toolbar class="elevation-0" height="45" color="gray">
          <v-toolbar-title>
            <h1 class="subheading">Update IMEI Keys</h1>
          </v-toolbar-title>

        </v-toolbar>
        <v-card-text>
          <v-layout justify-start="justify-start" row="row" fill-height="fill-height">
            <v-flex xs12>
              <v-text-field v-model="setting.imeiOrgKey" label="IMEI.org">
              </v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-text-field v-model="setting.imeiInfoKey" label="IMEI.info">
              </v-text-field>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
      <v-card class="border-r-0">
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" dark @click="update">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-layout>
  </v-container>
</template>
<script>
import { mapGetters } from "vuex";
import keyService from '../service.js';

export default {
  name: "create-User",
  data() {
    return {
      setting: {
        imeiInfoKey: null,
        imeiOrgKey: null,
      }
    };
  },
  computed: {
    ...mapGetters("global", ["currentUser"]),
  },
  async created() {
    await this.loadKey();
  },
  methods: {
    update() {
      console.log('saving press')
      return keyService
        .update(1, this.setting)
        .then((result) => {
          console.log(';lkajsdfl;asdkjf', result)
          if (result.status) {
            this.$swal
              .mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
              })
              .fire({
                type: "success",
                title: "Keys Updated!",
              });
          }
        })
        .catch((err) => {
          this.$swal
            .mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
            })
            .fire({
              type: "error",
              title: err.data.data,
            });
        });
    },
    loadKey() {
      keyService.getAll().then((response) => {
        console.log('response', response)
        this.setting = response.data[0]
      });
    },
  }
};
</script>
